/**
 * @generated SignedSource<<99dc60fb0697ad2e0e5cd6b0db0c6fed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type job_useApplyToJob$data = {
  readonly firm: {
    readonly contract: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "job_useApplyToJob";
};
export type job_useApplyToJob$key = {
  readonly " $data"?: job_useApplyToJob$data;
  readonly " $fragmentSpreads": FragmentRefs<"job_useApplyToJob">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "job_useApplyToJob",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Contract",
          "kind": "LinkedField",
          "name": "contract",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "5c56397fb736703c821e83c841c55eab";

export default node;
